"use strict";
/*
* Created on 20.05.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LostSaleDTO_1 = require("../model/LostSaleDTO");

var LostSaleConverter_1 = require("./LostSaleConverter");
/**
 * Implementation of {@link LostSaleConverter}.
 * @author ZSr
 */


var LostSaleConverterImpl =
/*#__PURE__*/
function (_LostSaleConverter_1$) {
  _inherits(LostSaleConverterImpl, _LostSaleConverter_1$);

  function LostSaleConverterImpl() {
    _classCallCheck(this, LostSaleConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(LostSaleConverterImpl).apply(this, arguments));
  }

  _createClass(LostSaleConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new LostSaleDTO_1.LostSaleDTO(LostSaleDTO_1.LostSaleDTO.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), LostSaleDTO_1.LostSaleDTO.schema.amount.valueOf(conversions.toBigNumber(source.amount)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        amount: conversions.fromBigNumber(source.amount)
      });
      return result;
    }
  }]);

  return LostSaleConverterImpl;
}(LostSaleConverter_1.LostSaleConverter);

exports.LostSaleConverterImpl = LostSaleConverterImpl;